"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepForm = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/form-parts/form/component");
const component_2 = require("@front/components/site-menu/component");
const backendImport_1 = require("@front/backendImport");
require("./children/questions-manager");
const DEFAULT_FORM = {
    title: '',
    description: '',
    order: 1,
    isShared: false,
    questions: []
};
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
  <div class="step-form-page">
    <div class="row">
      <div class="col-lg-8 col-12 pb-lg-5">
        <div class="mb-2">
          <h1>${x => x.stepId ? 'step.form.title.edit'.t() : 'step.form.title.add'.t()}</h1>
          <div class="text-zero top-right-button-container">
            <button @click="${(x, c) => x.back()}" type="button"
              class="top-right-button mr-1 btn btn-primary btn-lg">${'step.form.back'.t()}</button>
          </div>
        </div>
        <div class="card card-body mb-5">
          <the-form :onSubmit="${(x, c) => x.handleSubmit.bind(x)}">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <part-input 
                    required="true" 
                    class="form-part" 
                    label="${'step.form.title.label'.t()}" 
                    :value="${x => x.form.title}"
                    name="title" 
                    placeholder="${'step.form.title.placeholder'.t()}"
                  ></part-input>
                </div>
                <div class="form-group col-md-3">
                  <part-input 
                    required="true"
                    class="form-part" 
                    label="${'step.form.order.label'.t()}" 
                    :value="${x => x.form.order}"
                    name="order" 
                    type="number" 
                    placeholder="${'step.form.order.placeholder'.t()}"
                  ></part-input>
                </div>
                <div class="form-group col-md-3">
                  <part-switch 
                    class="form-part" 
                    label="${'step.form.isShared.label'.t()}" 
                    :value="${x => x.form.isShared}"
                    name="isShared"
                  ></part-switch>
                </div>
              </div>             
              <div class="form-group">
                <part-textarea 
                  class="form-part" 
                  label="${'step.form.description.label'.t()}" 
                  :value="${x => x.form.description}"
                  name="description" 
                  placeholder="${'step.form.description.placeholder'.t()}"
                ></part-textarea>
              </div>

              
              <div class="form-group">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <h5>${'step.form.questions.title'.t()}</h5>
                  <button @click="${x => x.addQuestion()}" type="button" class="btn btn-success">
                    <i class="simple-icon-plus"></i> ${'step.form.questions.add'.t()}
                  </button>
                </div>

                
                ${(0, fast_element_1.when)(x => x.questions && x.questions.length > 0, (0, fast_element_1.html) `
                  <div class="questions-container">
                    ${(0, fast_element_1.repeat)(x => x.questions, (0, fast_element_1.html) `
                      <div class="question-item mb-3" data-question-index="${(x, c) => c.index}">
                        <div class="d-flex justify-content-between align-items-start mb-2">
                          <h6 class="mb-0">${'step.form.questions.order'.t()} ${x => x.order + 1}</h6>
                          <button @click="${(x, c) => c.parent.removeQuestion(c.index)}" 
                            type="button" class="btn btn-sm btn-outline-danger">
                            <i class="simple-icon-trash"></i> ${'step.form.questions.remove'.t()}
                          </button>
                        </div>
                        <question-form 
                          :key="${x => x.order}"
                          :value="${x => x.data}"                          
                          @question-changed="${(x, c) => c.parent.handleQuestionChanged(c.event)}">
                        </question-form>
                      </div>
                    `)}
                  </div>
                `)}

                ${(0, fast_element_1.when)(x => (!x.questions || x.questions.length === 0), (0, fast_element_1.html) `
                  <div class="text-muted text-center py-3">
                    ${'step.form.questions.empty'.t()}
                  </div>
                `)}
              </div>

              
              <div class="form-group mt-4">
                <button @click="${(x, c) => x.sendSubmit(x, c)}" type="submit" class="btn btn-primary btn-lg mr-2"
                  ?disabled="${x => x.loading}">
                  ${x => x.stepId ? 'step.form.submit.update'.t() : 'step.form.submit.create'.t()}
                </button>
              </div>
            </the-form>
          </div>
        </div>
      </div>
    </div>
  </div>
  ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `<app-loader></app-loader>`)}
</div>`;
require("./styles/layout.scss");
const styles = T.css `.step-form-page {
  min-height: 100px;
}

.question-card {
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  background-color: #f8f9fa;
}
.question-card .card-body {
  padding: 1.5rem;
}
.question-card .card-title {
  color: #495057;
  font-weight: 600;
}

.question-options .input-group {
  margin-bottom: 0.5rem;
}
.question-options .input-group:last-child {
  margin-bottom: 0;
}

.add-question-btn {
  background-color: #28a745;
  border-color: #28a745;
}
.add-question-btn:hover {
  background-color: #218838;
  border-color: #1e7e34;
}

.remove-question-btn {
  background-color: #dc3545;
  border-color: #dc3545;
}
.remove-question-btn:hover {
  background-color: #c82333;
  border-color: #bd2130;
}`;
const shadowOptions = { "mode": "open" };
let StepForm = class StepForm extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.stepId = null;
        this.form = DEFAULT_FORM;
        this.questions = [];
        this.sendSubmit = component_1.FormComponent.sendSubmitEvent;
    }
    async connectedCallback() {
        super.connectedCallback();
        this.stepId = this.routeParams.id;
        this.form = {
            title: '',
            description: '',
            order: 1,
            isShared: false,
            questions: []
        };
        if (this.stepId) {
            await this.loadStep();
        }
        component_1.FormComponent.listenForValuesChange.bind(this)('form');
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.form = {
            title: '',
            description: '',
            order: 1,
            isShared: false,
            questions: []
        };
        this.questions = [];
    }
    async loadStep() {
        var _a;
        if (!this.stepId)
            return;
        this.loading = true;
        try {
            const response = await this.apiService.back.get('step.get', {
                routeParams: { id: this.stepId }
            });
            if (response.success && response.data) {
                const step = response.data;
                this.form = {
                    title: step.title,
                    description: step.description,
                    order: step.order,
                    isShared: step.isShared,
                    questions: step.questions || []
                };
                // Ensure each question has a unique ID and convert to IQuestionEntry format
                this.questions = (step.questions || []).map((question, index) => ({
                    order: index,
                    data: {
                        ...question,
                        order: index
                    }
                }));
            }
        }
        catch (e) {
            (_a = this.notifyService) === null || _a === void 0 ? void 0 : _a.notify('step.form.load.error'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    back() {
        component_2.SiteMenu.goto.bind(this)('/step/list');
    }
    addQuestion() {
        const newOrder = this.questions.length;
        const newQuestion = {
            order: newOrder,
            data: null
        };
        this.questions = [...this.questions, newQuestion];
    }
    handleQuestionChanged(event) {
        const eventData = event.detail;
        const updatedQuestion = eventData.question;
        const questionIndex = eventData.index;
        this.form.questions[questionIndex] = updatedQuestion;
        this.form = { ...this.form };
        console.log(this.form);
    }
    cleanupEmptyQuestions() {
        // Only remove questions that have been empty for a while and are not the last question
        // Don't remove if there's only one question or if it's actively being edited
        if (this.questions.length <= 1) {
            return; // Always keep at least one question
        }
        const validQuestions = this.questions.filter((questionEntry, index) => {
            // Keep the question if:
            // 1. It has a title
            // 2. It's the last question (so user can always add new ones)
            return (questionEntry.data && questionEntry.data.title && questionEntry.data.title.trim()) || index === this.questions.length - 1;
        });
        if (validQuestions.length !== this.questions.length) {
            // Reorder the remaining questions
            validQuestions.forEach((questionEntry, index) => {
                questionEntry.order = index + 1;
                if (questionEntry.data) {
                    questionEntry.data.order = index + 1;
                }
            });
            this.questions = validQuestions;
            // Update form with only the data portion of valid questions
            this.form.questions = validQuestions
                .filter(qe => qe.data && qe.data.title && qe.data.title.trim())
                .map(qe => qe.data);
        }
    }
    removeQuestion(index) {
        if (this.questions.length > index) {
            const updatedQuestions = [...this.questions];
            updatedQuestions.splice(index, 1);
            // Reorder remaining questions
            updatedQuestions.forEach((questionEntry, i) => {
                questionEntry.order = i + 1;
                if (questionEntry.data) {
                    questionEntry.data.order = i + 1;
                }
            });
            this.questions = updatedQuestions;
            this.form.questions = this.questions
                .filter(qe => qe.data && qe.data.title && qe.data.title.trim())
                .map(qe => qe.data);
        }
    }
    async handleSubmit(event) {
        var _a, _b, _c, _d;
        event.preventDefault();
        try {
            this.loading = true;
            // Create clean form data
            const formData = {
                ...this.form
            };
            let response;
            let actionText = this.stepId ? 'step.form.action.updated'.t() : 'step.form.action.created'.t();
            if (this.stepId) {
                response = await this.apiService.back.put('step.update', formData, { routeParams: { id: this.stepId } });
                (_a = this.notifyService) === null || _a === void 0 ? void 0 : _a.notify('step.form.submit.updateSuccess'.t(), 'info');
            }
            else {
                response = await this.apiService.back.post('step.create', formData);
            }
            if (response && response.success) {
                (_b = this.notifyService) === null || _b === void 0 ? void 0 : _b.notify('step.form.submit.success'.t().replace('{action}', actionText), 'info');
                for (const formPart of this.$('.form-part')) {
                    formPart.reset();
                }
                this.form = {
                    title: '',
                    description: '',
                    order: 1,
                    isShared: false,
                    questions: []
                };
                this.questions = [];
                component_2.SiteMenu.goto.bind(this)('/step/list');
            }
            else {
                (_c = this.notifyService) === null || _c === void 0 ? void 0 : _c.notify('step.form.submit.failed'.t().replace('{action}', actionText), 'error');
            }
        }
        catch (e) {
            const errorMessage = this.stepId ? 'step.form.submit.updateError'.t() : 'step.form.submit.createError'.t();
            (_d = this.notifyService) === null || _d === void 0 ? void 0 : _d.notify(errorMessage, 'error');
        }
        finally {
            this.loading = false;
        }
    }
};
exports.StepForm = StepForm;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], StepForm.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], StepForm.prototype, "stepId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof backendImport_1.IBackendStepPayload !== "undefined" && backendImport_1.IBackendStepPayload) === "function" ? _a : Object)
], StepForm.prototype, "form", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], StepForm.prototype, "questions", void 0);
exports.StepForm = StepForm = __decorate([
    (0, client_1.RWSView)('step-form', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], StepForm);
StepForm.defineComponent();
